import { SUBSCRIPTION_NAMES } from '@sdk/common/constants';
import type { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import { Feature } from '@sdk/common/features';

const getRequiredSubscriptionNameForFeature = (feature: Feature, currentUser: AuthUserType) => {
  if (currentUser.org.isToastBilling) {
    return 'Scheduling Pro';
  }

  return feature && !currentUser.orgSettings.isOldPremium
    ? SUBSCRIPTION_NAMES[currentUser.orgSettings.premiumFeatures[feature]]
    : SUBSCRIPTION_NAMES[1];
};

export default getRequiredSubscriptionNameForFeature;
